import React, { FunctionComponent, memo } from "react";
import { TbCircle } from "react-icons/tb";
import {
  Flex,
  Icon,
} from "@chakra-ui/react";
import { isEqual, range } from "lodash";

import { IAlgorithmReport } from "./types";
import { useControlUI } from "../ControlUIContext";

import AlgorithmResult from "./AlgorithmResult";


interface IProps {
  report: IAlgorithmReport;
}


const AlgorithmReport: FunctionComponent<IProps> = memo(function AlgorithmReport({
  report,
}) {
  const { expandedReports, chainLength } = useControlUI();

  return <>
    <Flex
      direction={expandedReports ? "column" : "row"}
    >
      {range(chainLength).map(i => (
        report.results[i]
          ? <AlgorithmResult key={i} algorithm_name={report.algorithm} result={report.results[i]} />
          : <Icon key={i} boxSize={5} color="transparent"><TbCircle size={24} /></Icon>
      ))}
    </Flex>
  </>
}, isEqual);

export default AlgorithmReport;
